import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import { FallecimientoService } from 'src/app/services/fallecimiento/fallecimiento.service';
import Swal from 'sweetalert2';
import { TiposService } from '../../services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../environments/environment';
import { Beneficiario } from '../../models/beneficiario/beneficiario.model';
import { isNullOrUndefined } from 'util';
import { Hijo } from '../../models/hijo/hijo.model';
import { isNull } from 'util';
import { NgForm } from '@angular/forms';
declare const Rut: any;

export interface DialogData
{
    archivo: any;
    idPostulacion: any;
    idFallecimiento: any;
    idUsuario: any;
    beneficiario: string;
   // postulantes: any;
    postulantes: any[];
    carga: boolean;
    fallecimientoBeneficiario: any;
    tipoNacimiento: any;
    deshabilitado: boolean;
    presionaEditar: boolean;
    recarga: boolean;
    email: string;
    checked: string;    
    scales: any
    rutHijo: string;
    nombreHijo: string;
    tipos: any;
    sumaCapital: any;
    fechaFallecimiento:any;
    nombreCompleto: string;
    mostrarEditar: string;
    rol: string;
    disponiblePago:any;
    mostrarAprobarButton:any;
    diasDiferencia:any;
    idCarga:any;
    nacido: boolean ;
    mostrarTitularCarga: boolean ;
    mostrarBeneficiarios: boolean ;
    beneficiarios: Beneficiario[];
   //beneficiariosArray: Beneficiario[] = [];
   //beneficiarios: Beneficiario[] = [];
    config:any;
  
    
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones/postulacion-fallecimiento-validar.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css'],
})
export class DialogEditPostulacionFallecimiento
{
    constructor( public dialogRef: MatDialogRef<DialogEditPostulacionFallecimiento>,
                public fallecimientoService: FallecimientoService,
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    {
        let vm = this
        this.data.recarga = false
       // this.data.nacido = false
       this.data.config = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
        this.data.mostrarTitularCarga = true
        this.data.rol = localStorage.getItem('rol')     
        this.data.mostrarBeneficiarios = false
        this.fallecimientoService.traeTipoFallecimiento().then(
            tipo => this.data.tipos = tipo
          ).catch(error => console.log(error))

      
       
     
           
    }

    onRechazarClick(): void
    {
        let vm = this

    
        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', email: this.data.email,
            nombreCompleto: this.data.nombreCompleto, nombreProducto: 'ESCOLARIDAD'
        }

        this.postulacionesService.motivoRechazo(2).then ( rechazos => { dataRechazo.tiposRechazo = rechazos
        } )
        .catch ( error => {

          console.log(error)
        } );

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe( () =>
        {

            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(): void
    {  
       
    
        let titular = true
        let rut=''
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        if(!isNullOrUndefined(this.data.postulantes) && !isNullOrUndefined(this.data.postulantes[0].tipoCarga)){
          
             rut=this.data.postulantes[0].rut
            titular=false
        }else{
            let limpiarRut=this.data.beneficiario.split("(");
            let obtenerRut= limpiarRut[1].split("-");
            rut= obtenerRut[0]
        }
              

        let vm = this
        let fechaIngresada = new Date(this.data.fechaFallecimiento + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)
        
       
        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
        (
            response =>
            {
               
               if(Object.values(response).length >1){            
                    vm.openAlertDialog('El rut ya tiene una solicitud de Fellecimiento ingresada, favor revisar.', 'btn-danger')
                    Swal.close();
                    return
               }    
             
               if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
               {
                   Swal.close();
                   this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
                   
               }else{
                   const dialogRef = this.dialog.open(ConfirmationDialog, {
                       data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                   })
           
                   dialogRef.afterClosed().subscribe((confirmed: boolean) =>
                   {
                       if (confirmed)
                       {
                         Swal.fire({
                           allowOutsideClick:false,
                           icon:'info',
                           text:'Cargando...'
                         });
                         Swal.showLoading();
                           vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO",idUsuarioSesion).then
                           (
                               () =>
                               {
                                   vm.data.recarga = true
                                   vm.dialogRef.close()
                                   Swal.close();
                                   vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                               }
                           )
                           .catch
                           (
                               error =>
                               {
                                   Swal.close();
                                   console.log(error)
                                   vm.dialogRef.close()
                                   vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                               }
                           )
                       }
                   })
               }
               
            }
        )
        .catch
        (
            () =>
            {
                if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                {
                    Swal.close();
                    this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
                    
                }else{
                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })
            
                    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
                    {
                        if (confirmed)
                        {
                          Swal.fire({
                            allowOutsideClick:false,
                            icon:'info',
                            text:'Cargando...'
                          });
                          Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO",idUsuarioSesion).then
                            (
                                () =>
                                {
                                    vm.data.recarga = true
                                    vm.dialogRef.close()
                                    Swal.close();
                                    vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                }
                            )
                            .catch
                            (
                                error =>
                                {
                                    Swal.close();
                                    console.log(error)
                                    vm.dialogRef.close()
                                    vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                }
                            )
                        }
                    })
                }     
           
            }
        )
     
    }

    onEditarClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }
   
    onDescargarArchivosClick(postulacionId: any)
    {   
        let vm = this
     
        vm.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`    
                    window.open(fileURL,'_blank')                     
                })  
               
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }
  
    onGuardarClick()
    {   
        console.log(this.data)
        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let idUsuario = this.data.idUsuario
        let fecha = this.data.fechaFallecimiento.split('-')
        let fechaFormateada = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
        let fechaIngresada = new Date(this.data.fechaFallecimiento + 'T00:00')   
    

        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        let fechaMinima = new Date()
        let fechaFallIngresada = new Date(this.data.fechaFallecimiento + 'T00:00')
    
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)
        if (this.data.rutHijo && !Rut(this.data.rutHijo)) {
          Swal.close();
          this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
          return false    
        }
    
        if ((fechaFallIngresada < fechaMinima || fechaFallIngresada > new Date())) {
          this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
          Swal.close();
          return false
        }
        if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
        {
            Swal.close();
            this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
            
        }else{
            
            this.fallecimientoService.editarFallecimiento(this.data, fechaFormateada,idUsuario,idUsuarioSesion).then
            (
                () =>
                {
                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) =>
                {
                  if (error.status == 406) {
                    vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo rut de hijo.', 'btn-danger')
                    Swal.close();
                  }else if (error.status == 402) {
                      vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                      Swal.close();
                  } else if(error.status == 412){
                      vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                      Swal.close();    
                  }else{
                    vm.dialogRef.close()                  
                    vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                    Swal.close();
                  }
                 
                }
            )
        }
    }


    
    muestraRecienNacido(event: any) {
        let vm = this
        this.data.nacido = false;
       
          if (event.target.checked) {
            this.data.nacido = true;      
            this.data.mostrarTitularCarga = false;
            if (this.data.rol != 'ROLE_AFILIADO' && this.data.rol != 'ROLE_JUBILADO') {
              this.data.mostrarBeneficiarios = false;
            }
          } else {
            this.data.nacido = false;      
            this.data.mostrarTitularCarga = true;
            if (this.data.rol != 'ROLE_AFILIADO' && this.data.rol != 'ROLE_JUBILADO') {
              this.data.mostrarBeneficiarios = true;
            }
          }
        
      }

      esconderBeneficiarios(parentesco: string) {
        let vm = this
        this.data.mostrarBeneficiarios = false;
       
        if (parentesco == 'TITULAR' && vm.data.scales == false) {
          this.data.mostrarBeneficiarios = true;
        } else {
          this.data.mostrarBeneficiarios = false;
        }
      }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

/*
    agregarBeneficiario(form: NgForm) {
        let vm = this
        let beneficiarioAgregado: any = []
        let tipoIngresoParentesco: any
        let tipoParentescoId: any
    
    
        if (!vm.data.beneficiarios.nombreApellidoBeneficiario) {
          vm.openAlertDialog('El campo nombre y apellido no debe ir vacio', 'btn-danger')
          Swal.close();
          return false;
        }
      
        if (vm.data.beneficiarios.rutBeneficiario == vm.buscador.rutAfiliado) {
          vm.openAlertDialog('El rut del beneficiario no debe ser igual al del titular', 'btn-danger')
          Swal.close();
          return false;
        }
        
    
        if (!vm.data.beneficiarios.rutBeneficiario) {
          vm.openAlertDialog('El campo rut no debe ir vacio', 'btn-danger')
          Swal.close();
          return false;
        }
    
        if (!Rut(vm.data.beneficiarios.rutBeneficiario)) {
          console.log(vm.data.beneficiarios.rutBeneficiario)
          this.openAlertDialog('El RUT tiene un formato incorrecto. Favor Revisar', 'btn-danger')
          Swal.close();
          return false;
        }
    
        if (!vm.data.beneficiarios.capitalBeneficiario) {
          vm.openAlertDialog('El campo capital no debe ir vacio', 'btn-danger')
          Swal.close();
          return false;
        }
    
        if (vm.data.beneficiarios.capitalBeneficiario < 1 || vm.data.beneficiarios.capitalBeneficiario > 100) {
          vm.openAlertDialog('El porcentaje del capital debe ir entre 1 y 100 %', 'btn-danger')
          Swal.close();
          return false;
        }
    
        if (Number(vm.data.sumaCapital) + Number(vm.data.beneficiarios.capitalBeneficiario) > 100) {
          vm.openAlertDialog('El porcentaje sumado de los beneficiarios no debe superar el 100%', 'btn-danger')
          Swal.close();
          return false;
        }
    
    
        for (let i = 0; i < this.tipos.length; i++) {
          if (this.tipos[i].id == vm.fallecimiento.tipoParentesco) {
            tipoIngresoParentesco = this.tipos[i].descripcion;
            tipoParentescoId = this.tipos[i].id;
          }
        }
       
        beneficiarioAgregado.push({
          nombreApellidoBeneficiario: vm.data.beneficiarios.nombreApellidoBeneficiario,
          parentescoBeneficiario: tipoIngresoParentesco,
          tipoParentescoId: tipoParentescoId,
          rutBeneficiario: vm.data.beneficiarios.rutBeneficiario,
          nombres: vm.data.beneficiarios.parentescoBeneficiario,
          capitalBeneficiario:vm.data.beneficiarios.capitalBeneficiario,
        })
    
        this.data.sumaCapital = Number(this.data.sumaCapital) + Number( vm.data.beneficiarios.capitalBeneficiario);
    
    
      //  vm.data.beneficiario.push(beneficiarioAgregado)
    
        vm.data.beneficiarios.nombreApellidoBeneficiario = ''
        vm.data.beneficiarios.tipoIngresoParentesco = 0
        vm.data.beneficiarios.tipoParentescoId = 0
        vm.data.beneficiarios.rutBeneficiario = ''
        vm.data.beneficiarios.capitalBeneficiario = 0
    
    
        vm.data.config.currentPage = 1
        vm.data.config.totalItems = 5
    
    
      }
      */
       validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }

  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {

      this.fallecimientoService.buscarHijo(rut).then
        (
          (hijo: Hijo) => {
            console.log(hijo)
            vm.data.nombreHijo = hijo.nombres
            Swal.close();
          }

        ).catch(error => {
          console.log(error)
          Swal.close();
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
          vm.data.nombreHijo = ''
        
        })
    } else {
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.data.nombreHijo = ''
    }
  }
}
